module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex align-center flex-wrap"
  }, [_c('v-switch', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.busy,
      "hide-details": "",
      "label": "Accepting feedback",
      "loading": _vm.busy,
      "input-value": _vm.accepting
    },
    on: {
      "change": function($event) {
        _vm.change(Boolean($event))
      }
    }
  }), _vm._v(" "), (_vm.accepting && _vm.expiresAt) ? _c('span', {
    staticClass: "ml-3 text-caption"
  }, [_vm._v("Valid until " + _vm._s(new Date(_vm.expiresAt).toLocaleString()))]) : _vm._e()], 1), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('v-alert', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), (_vm.link) ? _c('v-btn', {
    attrs: {
      "color": "secondary",
      "disabled": _vm.busy
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy link")]) : _vm._e(), _vm._v(" "), (_vm.link) ? _c('v-text-field', {
    attrs: {
      "label": "Feedback link",
      "value": _vm.link,
      "readonly": ""
    },
    on: {
      "focus": function($event) {
        return $event.target.select()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55fbd3df"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/FeedbackAccessPanel.vue
// module id = 2132
// module chunks = 0